module.exports = __webpack_public_path__ + "img/vue1-arriere_blanc.f08def4b.png";